var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-disclosure-dropdown-item',{directives:[{name:"gl-modal",rawName:"v-gl-modal.confirm-rollback-modal",modifiers:{"confirm-rollback-modal":true}}],attrs:{"item":_vm.item},on:{"action":_vm.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }